import type React from 'react';

import LibraryTrainingPlans, { type TitleVariant } from 'app/ui/components/molecules/library-training-plans';
import LibraryTrainingPlansSkeleton from 'app/ui/components/molecules/library-training-plans/skeleton';
import type { LibraryTrainingPlansState } from 'app/ui/components/molecules/library-training-plans/use-library-training-plans';

type LibraryTrainingPlansSectionProps = {
  titleVariant?: TitleVariant;
  /** From `useLibraryTrainingPlans`, called by the page so the plans load alongside the page query. */
  trainingPlans: LibraryTrainingPlansState;
};

/**
 * The training-plans section as home and the library render it: a skeleton in the slot while the
 * plans are still loading, the real section once they are in, and nothing at all (rather than a
 * broken page) when they cannot be fetched - the plans are supplementary to the content around them.
 */
const LibraryTrainingPlansSection: React.FC<LibraryTrainingPlansSectionProps> = ({
  titleVariant = 'h3',
  trainingPlans,
}) => {
  switch (trainingPlans.status) {
    case 'loading':
      return <LibraryTrainingPlansSkeleton titleVariant={titleVariant} />;
    case 'unavailable':
      return null;
    case 'ready':
      return (
        <LibraryTrainingPlans
          titleVariant={titleVariant}
          planInstances={trainingPlans.planInstances}
          plans={trainingPlans.plans}
        />
      );
    default:
      return null;
  }
};

export default LibraryTrainingPlansSection;
